<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {addDays, format} from 'date-fns'
    import {clone, hotelAddressToString} from '~/utils/helpers'

    @Component({expose: ['reset', 'tourists', 'status', 'requestBody', 'touristsSelect']})
    export class OfflineServiceMixin extends Vue {
        @Prop() orderTravelers
        @Prop() clientPerson
        @Prop() orderProcessId
        @Prop() serviceToModify
        @Prop({required: true}) clientType
        @Prop({required: true}) customerCompanyId
        @Prop() order
        @Prop() info

        newSupplierMode = false

        type = null
        status = null
        refNumber = null
        name = null
        address = null
        supplierId = null

        startDate = null
        endDate = null
        quantityOfTravelers = null
        description = ''
        comment = null
        dueToConfirmDate = null
        salesTermSupplier = {
            type: 'SUPPLIER',
            price: {amount: 0, currency: 'EUR', commission: {amount: 0}},
            cancelPenalty: [],
        }
        salesTermClient = {
            type: 'CLIENT',
            price: {amount: 0, currency: 'EUR', commission: {amount: 0}},
            cancelPenalty: [],
        }
        tourists = []
        product = {}
        PNRRequestDataInit = null
        isATOL = false
        PNRData = null

        bookingXR = null
        serviceCreationXR = null

        isResetFinished = false

        salesTermsInitedSupplier = false
        salesTermsInitedClient = false

        seatsPrebooked = false
        seatsVisibleForClient = false
        seats = []

        async reset() {
            this.isResetFinished = false
            this.salesTermsInitedSupplier = false
            this.salesTermsInitedClient = false
            this.name = null
            this.refNumber = null
            this.supplierId = null
            this.description = ''
            this.address = null
            this.type = this.types[0].value
            this.status = this.statuses[2].value
            this.startDate = format(new Date(), 'yyyy-MM-dd')
            this.endDate = format(addDays(new Date(), 6), 'yyyy-MM-dd')
            this.newSupplierMode = false
            this.dueToConfirmDate = null
            this.quantityOfTravelers = null
            this.product = {}

            if (this.isShowClientCommissionVAT && this.salesTermClient.price.commissionVatAmount === undefined) {
                this.salesTermClient.price.commissionVatAmount = 0
            }
            this.seatsPrebooked = false
            this.seatsVisibleForClient = this.$conf.public.seatsVisibleForClient
            this.seats = []

            this.bookingXR = this.serviceToModify?.serviceExchangeRates?.bookingXR || null
            this.serviceCreationXR = this.serviceToModify?.serviceExchangeRates?.serviceCreationXR || null

            if (!this.serviceToModify && !this.PNRRequestDataInit) {
                this.salesTermSupplier.price.amount = 0
                this.salesTermSupplier.price.commission.amount = 0
                this.salesTermSupplier.cancelPenalty = []

                this.salesTermClient.price.amount = 0
                this.salesTermClient.price.commission.amount = 0
                this.salesTermClient.cancelPenalty = []
            }
            if (this.serviceToModify) {
                await this.fillProductData()
            } else if (this.PNRRequestDataInit) {
                await this.fillPNRData()
            } else {
                if (this.$conf.public.account.addOfflineServiceSingleCurrencyClientPrice) {
                    this.salesTermClient.price.currency = authStore.systemCurrency
                }
            }
            this.isResetFinished = true
        }

        async fillPNRData() {
            this.PNRData = await this.getPNRData()

            this.type = this.PNRData.type || this.type
            this.status = this.PNRData.status || this.status
            this.name = this.PNRData.name || this.name
            this.refNumber = this.PNRData.refNumber || this.refNumber
            this.supplierId = this.PNRData.supplierId || this.supplierId
            this.startDate = this.PNRData.startDate || this.startDate
            this.endDate = this.PNRData.endDate || this.endDate
            this.product = this.PNRData.product || this.product
            this.description = this.PNRData.description || this.description

            //TODO костыль, в будуем sales terms для PNR будут приходить в АПИ
            this.salesTermSupplier = {
                type: 'SUPPLIER',
                price: {amount: 0, currency: 'EUR', commission: {amount: 0}},
                cancelPenalty: [],
            }
            this.salesTermClient = {
                type: 'CLIENT',
                price: {amount: 0, currency: 'EUR', commission: {amount: 0}},
                cancelPenalty: [],
            }

            this.quantityOfTravelers = this.PNRData.quantityOfTravelers || this.quantityOfTravelers
            await this.$nextTick
            this.tourists = this.PNRData.tourists || this.tourists
        }

        //TODO костыль, в будуем sales terms для PNR будут приходить в АПИ
        onSalesTermsInitAll() {
            if (this.PNRRequestDataInit && this.PNRData) {
                this.$refs.SUPPLIERSaleTerm.priceAmount = this.PNRData.salesTermSupplier.price.amount
                this.$refs.SUPPLIERSaleTerm.commission = this.PNRData.salesTermSupplier.price.commission.amount

                this.salesTermSupplier.price.currency = this.PNRData.salesTermSupplier.price.currency

                this.PNRRequestDataInit = null
            }
        }

        onSalesTermsInitSupplier() {
            this.salesTermsInitedSupplier = true

            if (this.salesTermsInitedClient) {
                this.onSalesTermsInitAll()
            }
        }

        onSalesTermsInitClient() {
            this.salesTermsInitedClient = true

            if (this.salesTermsInitedSupplier) {
                this.onSalesTermsInitAll()
            }
        }

        async getPNRData() {
            return {
                type: 'FLIGHT',
                status: 'QUOTE',
                name: 'Paris - London',
                refNumber: this.PNRRequestDataInit?.refNumber || this.refNumber,
                supplierId: this.PNRRequestDataInit?.supplierId || this.supplierId,
                startDate: '2024-12-01',
                endDate: '2024-12-01',
                quantityOfTravelers: 3,
                product: {
                    marketingAirline: 'LH',
                    segments: [
                        {
                            brandedFare: {name: ''},
                            departureAirportCode: 'CDG',
                            departureTerminal: '',
                            departureDate: '2024-12-01T10:09',
                            arrivalDate: '2024-12-01T12:02',
                            flightNumber: 'LH717',
                            flightClass: 'Economy',
                            bookingClass: 'Y',
                            arrivalTerminal: '',
                            arrivalAirportCode: 'LHR',
                        },
                    ],
                },
                description: '<p>&nbsp;<strong>PNR </strong><i><strong>description</strong></i></p>',
                salesTermSupplier: {
                    type: 'SUPPLIER',
                    price: {amount: 123, currency: 'AUD', commission: {amount: 2.46}},
                    cancelPenalty: [],
                },
                tourists: [
                    {
                        prefix: 'Mr',
                        firstName: 'John',
                        lastName: 'Doe',
                        birthdate: '2001-05-10',
                        citizenshipId: 124567,
                        type: 'ADULT',
                    },
                    {prefix: 'Mr', firstName: 'Mark', lastName: 'Smith', birthdate: '1986-05-15', type: 'ADULT'},
                    {type: 'ADULT', prefix: 'Mrs', firstName: 'Dana', lastName: 'Jones', birthdate: '1981-08-15'},
                ],
            }
        }

        async fillProductData() {
            this.type = this.serviceToModify.serviceDetails[0].extraServiceProductType
            if (this.type === 'TRANSFER' || this.type === 'EXCURSION') {
                if ('seatsPrebooked' in this.serviceToModify) {
                    this.seatsPrebooked = this.serviceToModify?.seatsPrebooked
                }
                if ('seatsVisibleForClient' in this.serviceToModify) {
                    this.seatsVisibleForClient = this.serviceToModify.seatsVisibleForClient
                }
            }
            this.status =
                this.serviceToModify.status === 'PreConfirmed'
                    ? 'PRE-BOOKING'
                    : this.serviceToModify.status.toUpperCase()
            if (this.status !== 'PRE-BOOKING') {
                this.dueToConfirmDate = null
            } else {
                this.dueToConfirmDate = this.serviceToModify?.dueToConfirmDate?.split(' ').join('T') || null
            }
            this.name = this.serviceToModify.serviceName
            if (
                this.serviceToModify.serviceDetails[0].extraServiceProductType === 'ACCOMMODATION' &&
                this.serviceToModify.serviceDetails[0]?.hotelId &&
                this.info?.address
            ) {
                this.address = hotelAddressToString(this.info.address)
            }
            this.refNumber = this.serviceToModify.refNum
            this.supplierId = this.serviceToModify.supplierId
            this.description = this.serviceToModify.serviceDetails[0].description
            this.comment = this.serviceToModify.comments
            this.quantityOfTravelers = this.serviceToModify.serviceDetails[0]?.quantityOfTravelers
            if (this.comment === 'ATOL') {
                this.isATOL = true
            }

            const supplierSalesTerms = this.serviceToModify.salesTerms.find(e => e.type === 'SUPPLIER')
            const clientSalesTerms = this.serviceToModify.salesTerms.find(e => e.type === 'CLIENT')

            this.salesTermSupplier = {
                type: 'SUPPLIER',
                price: {
                    amount: supplierSalesTerms.price.amount || 0,
                    currency: supplierSalesTerms.price.currency,
                    commission: {
                        amount: supplierSalesTerms.price.commission || 0,
                        percent: supplierSalesTerms.price.commissionPercent,
                    },
                },
                cancelPenalty: supplierSalesTerms.cancelPenalty.map(c => ({
                    amount: c.amount,
                    startDateTime: c.startDateTime?.split(' ')[0],
                    endDateTime: c.endDateTime?.split(' ')[0],
                })),
            }

            this.salesTermClient = {
                type: 'CLIENT',
                ...(clientSalesTerms.commissionVatRate !== undefined && {
                    commissionVatRate: clientSalesTerms.commissionVatRate,
                }),
                price: {
                    amount: clientSalesTerms.price.amount || 0,
                    currency: clientSalesTerms.price.currency,
                    commission: {
                        amount: clientSalesTerms.price.commission || 0,
                        percent: clientSalesTerms.price.commissionPercent,
                    },
                    ...(this.isShowClientCommissionVAT && {
                        commissionVatAmount: clientSalesTerms.commissionVatAmount || 0,
                    }),
                },
                cancelPenalty: clientSalesTerms.cancelPenalty.map(c => ({
                    amount: c.amount,
                    startDateTime: c.startDateTime?.split(' ')[0],
                    endDateTime: c.endDateTime?.split(' ')[0],
                })),
            }

            switch (this.serviceToModify.serviceDetails[0].extraServiceProductType) {
                case 'ACCOMMODATION':
                    this.product = {
                        ...(this.serviceToModify.serviceDetails[0].roomType && {
                            roomType: this.serviceToModify.serviceDetails[0].roomType,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].mealType && {
                            mealType: this.serviceToModify.serviceDetails[0].mealType,
                        }),
                        quantityOfRooms: this.serviceToModify.serviceDetails[0]?.quantityOfRooms || 1,
                        ...(this.serviceToModify.serviceDetails[0]?.hotelId && {
                            hotelId: this.serviceToModify.serviceDetails[0].hotelId,
                        }),
                    }
                    break
                case 'TRANSFER':
                    this.product = {
                        ...(this.serviceToModify.serviceDetails[0].pickUpPoint && {
                            pickUpPoint: this.serviceToModify.serviceDetails[0].pickUpPoint,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].pickUpTime && {
                            pickUpTime: this.serviceToModify.serviceDetails[0].pickUpTime,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].dropOffPoint && {
                            dropOffPoint: this.serviceToModify.serviceDetails[0].dropOffPoint,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].dropOffTime && {
                            dropOffTime: this.serviceToModify.serviceDetails[0].dropOffTime,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].oneWay && {
                            oneWay: this.serviceToModify.serviceDetails[0].oneWay,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].groupTransfer && {
                            groupTransfer: this.serviceToModify.serviceDetails[0].groupTransfer,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].duration && {
                            duration: this.serviceToModify.serviceDetails[0].duration,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].contactNumber && {
                            contactNumber: this.serviceToModify.serviceDetails[0].contactNumber,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].vehicleType && {
                            vehicleType: this.serviceToModify.serviceDetails[0].vehicleType,
                        }),
                    }
                    break
                case 'EXCURSION':
                    this.product = {
                        ...(this.serviceToModify.serviceDetails[0].durationTime && {
                            durationTime: this.serviceToModify.serviceDetails[0].durationTime,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].durationDays && {
                            durationDays: this.serviceToModify.serviceDetails[0].durationDays,
                        }),
                    }
                    break
                case 'CAR_RENT':
                    this.product = {
                        ...(this.serviceToModify.serviceDetails[0].pickUpPoint && {
                            pickUpPoint: this.serviceToModify.serviceDetails[0].pickUpPoint,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].pickUpTime && {
                            pickUpTime: this.serviceToModify.serviceDetails[0].pickUpTime,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].dropOffPoint && {
                            dropOffPoint: this.serviceToModify.serviceDetails[0].dropOffPoint,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].dropOffTime && {
                            dropOffTime: this.serviceToModify.serviceDetails[0].dropOffTime,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].vehicleCategory && {
                            vehicleCategory: this.serviceToModify.serviceDetails[0].vehicleCategory,
                        }),
                    }
                    break
                case 'CRUISE':
                    this.product = {
                        ...(this.serviceToModify.serviceDetails[0].pickUpPoint && {
                            pickUpPoint: this.serviceToModify.serviceDetails[0].pickUpPoint,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].dropOffPoint && {
                            dropOffPoint: this.serviceToModify.serviceDetails[0].dropOffPoint,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].shipName && {
                            shipName: this.serviceToModify.serviceDetails[0].shipName,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].cruiseLine && {
                            cruiseLine: this.serviceToModify.serviceDetails[0].cruiseLine,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].cabinNumber && {
                            cabinNumber: this.serviceToModify.serviceDetails[0].cabinNumber,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].deckNumber && {
                            deckNumber: this.serviceToModify.serviceDetails[0].deckNumber,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].deckName && {
                            deckName: this.serviceToModify.serviceDetails[0].deckName,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].cabinCategory && {
                            cabinCategory: this.serviceToModify.serviceDetails[0].cabinCategory,
                        }),
                        ...(this.serviceToModify.serviceDetails[0].cabinTypeName && {
                            cabinTypeName: this.serviceToModify.serviceDetails[0].cabinTypeName,
                        }),
                    }
                    break
                case 'FLIGHT':
                    this.product = {
                        ...(this.serviceToModify.serviceDetails[0].marketingAirline && {
                            marketingAirline: this.serviceToModify.serviceDetails[0].marketingAirline,
                        }),
                        segments: this.serviceToModify.serviceDetails[0].segments
                            ? this.serviceToModify.serviceDetails[0].segments.map(
                                  ({flightSegmentName, ...segment}) => ({
                                      ...segment,
                                      departureDate: segment.departureDate?.split(' ').join('T') || null,
                                      arrivalDate: segment.arrivalDate?.split(' ').join('T') || null,
                                      brandedFare: segment.brandedFare ? {name: segment.brandedFare.name} : {name: ''},
                                      seats: [...segment.seats.map(seat => ({...seat}))],
                                  })
                              )
                            : [{}],
                    }

                    break
            }
            this.startDate = this.serviceToModify.startDateTime?.split(' ')?.[0]
            this.endDate = this.serviceToModify.endDateTime?.split(' ')?.[0]
        }

        get requestBody() {
            let serviceExchangeRates

            if (this.$refs?.CLIENTSaleTerm?.exchangeRate) {
                serviceExchangeRates = {
                    ...(this.status === 'CONFIRMED' && {bookingXR: this.$refs?.CLIENTSaleTerm.exchangeRate}),
                    ...(this.status !== 'CONFIRMED' && {serviceCreationXR: this.$refs?.CLIENTSaleTerm.exchangeRate}),
                }
            }

            const salesTermSupplierCopy = clone(this.salesTermSupplier)
            const salesTermClientCopy = clone(this.salesTermClient)

            delete salesTermSupplierCopy.price.commission.percent
            delete salesTermClientCopy.price.commission.percent

            return {
                orderProcessId: this.orderProcessId,
                productType: this.type,
                name: this.name,
                status: this.status,
                refNum: this.refNumber,
                supplierId: this.supplierId,
                quantityOfTravelers: this.quantityOfTravelers,
                startDate: this.startDate.split(' ').join('T'),
                endDate:
                    this.type === 'BANK_FEE' ? this.startDate.split(' ').join('T') : this.endDate.split(' ').join('T'),
                description: this.description,
                comment:
                    this.showATOLSwitcher && this.type === 'FLIGHT' ? (this.isATOL ? 'ATOL' : 'NO ATOL') : this.comment,
                ...(this.dueToConfirmDate && {dueToConfirmDate: this.dueToConfirmDate}),
                nettoPrice: {
                    ...salesTermSupplierCopy.price,
                },
                bruttoPrice: {
                    ...salesTermClientCopy.price,
                },
                supplierPenalties: this.salesTermSupplier.cancelPenalty.map(e => {
                    return {
                        dateFrom: e.startDateTime,
                        dateTo: e.endDateTime,
                        price: {
                            currency: this.salesTermSupplier.price.currency,
                            amount: e.amount,
                        },
                    }
                }),
                clientPenalties: this.salesTermClient.cancelPenalty.map(e => {
                    return {
                        dateFrom: e.startDateTime,
                        dateTo: e.endDateTime,
                        price: {
                            currency: this.salesTermClient.price.currency,
                            amount: e.amount,
                        },
                    }
                }),
                tourists: this.type === 'BANK_FEE' ? [] : this.tourists,
                product: this.product,
                ...(serviceExchangeRates && {serviceExchangeRates}),
                ...((this.type === 'TRANSFER' || this.type === 'EXCURSION') && {
                    modifyManualSeat: this.seats,
                    seatsVisibleForClient: this.seatsVisibleForClient,
                    seatsPrebooked: this.seatsPrebooked,
                }),
            }
        }

        get showATOLSwitcher() {
            return false
        }

        get isShowClientCommissionVAT() {
            return this.clientType !== 'DIRECT_SALES' && this.clientType !== 'CORPORATE'
        }

        get types() {
            const types = [
                {
                    name: this.$t('serviceType.ACCOMMODATION'),
                    value: 'ACCOMMODATION',
                },
                {
                    name: this.$t('serviceType.TRANSFER'),
                    value: 'TRANSFER',
                },
                {
                    name: this.$t('serviceType.FLIGHT'),
                    value: 'FLIGHT',
                },
                {
                    name: this.$t('serviceType.EXCURSION'),
                    value: 'EXCURSION',
                },
                {
                    name: this.$t('serviceType.CARRENT'),
                    value: 'CAR_RENT',
                },
                {
                    name: this.$t('serviceType.INSURANCE'),
                    value: 'INSURANCE',
                },
                {
                    name: this.$t('serviceType.TOUR'),
                    value: 'TOUR',
                },
                {
                    name: this.$t('serviceType.OWNVISA'),
                    value: 'VISA',
                },
                {
                    name: this.$t('serviceType.CRUISE'),
                    value: 'CRUISE',
                },
            ]

            if (this.$conf.public.bankServiceFee) {
                types.push({
                    name: this.$t('serviceType.BANK_FEE'),
                    value: 'BANK_FEE',
                })
            }

            types.push({
                name: this.$t('serviceType.OTHER'),
                value: 'OTHER',
            })

            return types
        }

        get statuses() {
            const statuses = this.serviceToModify
                ? [
                      'CONFIRMED',
                      'CONFIRMATION PENDING',
                      'CANCELED',
                      'CANCELLATION PENDING',
                      'MODIFICATION PENDING',
                      'REJECTED',
                      'QUOTE',
                      'PRE-BOOKING',
                  ]
                : ['CONFIRMED', 'CONFIRMATION PENDING', 'QUOTE', 'PRE-BOOKING']

            return statuses.map(value => ({value, title: this.$t(`bookingStatus.${value.split(' ').join('_')}`)}))
        }

        get touristsSelect() {
            return this.orderTravelers.map(({prefix, name, dateOfBirth, citizenshipId, isChild, email, phone}) => ({
                name: `${prefix || ''} ${name[0].firstName || ''} ${name[0].lastName || ''}`,
                value: {
                    prefix,
                    firstName: name[0].firstName,
                    lastName: name[0].lastName,
                    birthdate: dateOfBirth,
                    citizenshipId,
                    type: isChild ? 'CHILD' : 'ADULT',
                    email,
                    phone,
                },
            }))
        }
    }

    export default OfflineServiceMixin
</script>
